var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-select',{staticClass:"d-block",attrs:{"value":_vm.selected,"placeholder":_vm.plc || _vm.$t('message.group'),"filterable":"","clearable":"","size":_vm.size},on:{"input":_vm.dispatch}},_vm._l((_vm.categories),function(category){return _c('el-option',{key:category.id,attrs:{"label":category.name,"value":category.id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }